// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ls-pics[data-v-b587ca0a]{display:flex;align-items:flex-start;flex-wrap:wrap}.ls-pics img[data-v-b587ca0a]{width:100px}", ""]);
// Exports
module.exports = exports;
